"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDistributorProduct = void 0;
const routes_1 = require("../../routes");
const updateDistributorProduct = (client) => async (params, payload) => {
    const response = await client.put(routes_1.ENDPOINTS.UPDATE_DISTRIBUTOR_PRODUCT.applyParams(params), {
        ...payload,
    });
    return response.data;
};
exports.updateDistributorProduct = updateDistributorProduct;
